import type { FC } from 'react'
import styled from '@emotion/styled'
import { m } from 'framer-motion'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import EnableDataDrivenDecisionMakingImage from './EnableDataDrivenDecisionMakingImage'

const copy = {
  heading: `Enable data-driven decision making`,
}

const list = [
  {
    title: `Trust your analytics results`,
    description: `Help every team drive positive business impact by making trusted, real-time customer data accessible in tools and reports they want to use.`,
  },
  {
    title: `Focus on experimentation, not data clean up`,
    description: `Combine historical user activity data, demographic data, and transactional data to uncover insights, test ideas, and measure results.`,
  },
]

const EnableDataDrivenDecisionMaking: FC = () => {
  return (
    <SectionBase variant="2Col" reverse={true}>
      <Section.Copy>
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <StyledColumnTrack>
            {list.map(({ title, description }, index) => (
              <FeatureBoxBase key={index} alignment="left">
                <FeatureBox.Body>
                  <FeatureBox.Title>{title}</FeatureBox.Title>
                  <FeatureBox.Text>{description}</FeatureBox.Text>
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </StyledColumnTrack>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <Contents>
          <ImageWrapper
            initial={{ opacity: 0 }}
            whileInView={{
              opacity: 1,
              transition: {
                duration: 0.4,
                delay: 0.1,
              },
            }}
            viewport={{ once: true }}
          >
            <EnableDataDrivenDecisionMakingImage />
          </ImageWrapper>
        </Contents>
      </Section.Contents>
    </SectionBase>
  )
}

export default EnableDataDrivenDecisionMaking

const Contents = styled.div`
  position: relative;
  height: 100%;
`

const StyledColumnTrack = styled(ColumnTrack)`
  padding-top: 24px;
`

const ImageWrapper = styled(m.div)``
